import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  updateUserLocaleRequest: ["locale"],
  updateUserLocaleSuccess: ["status"],
  updateUserLocaleFailure: null,
});

export const UpdateUserLocaleTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  locale: null,
  status: null,
});

export const UpdateUserLocaleSelectors = {
  getData: (state: any) => state.updateUserLocale.data,
  isFetching: (state: any) => state.updateUserLocale.fetching,
  isSuccess: (state: any) => state.updateUserLocale.success,
  hasError: (state: any) => state.updateUserLocale.error,
};

export const request = (state: any, { locale }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    locale,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_USER_LOCALE_REQUEST]: request,
  [Types.UPDATE_USER_LOCALE_SUCCESS]: success,
  [Types.UPDATE_USER_LOCALE_FAILURE]: failure,
});
